module.exports = __webpack_public_path__ + "static/media/savings-account.12b8b77d.svg";